import { useState } from 'react';
import { Box } from '@mantine/core';
import { useParams } from 'react-router';
import useFetch from '../../../helpers/useFetch';
import ErrorMessage from '../../ErrorMessage';
import Spinner from '../../Spinner';
import GoogleAdForm from './GoogleAdForm';

const GoogleAdDetailsForm = ({ googleAd, close, onBack, onDuplicate, showUserFlow }) => {
  const fetch = useFetch();
  const [userError, setUserError] = useState();
  const { accountId, domainId } = useParams();

  const update = (googleAd) => {
    return fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/googleAds/${googleAd.id}`, {
      method: 'PUT',
      body: JSON.stringify(googleAd),
    })
      .then(close)
      .catch(setUserError);
  };

  const del = (cb) => {
    return fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/googleAds/${googleAd.id}`, {
      method: 'DELETE',
    }).then(() => {
      if (typeof cb === 'function') {
        cb();
      }
      close();
    });
  };

  if (googleAd === undefined) {
    return <Spinner />;
  }

  return (
    <>
      {googleAd === null ? (
        <ErrorMessage message="Google Ad has been deleted." />
      ) : (
        <GoogleAdForm
          googleAd={googleAd}
          saveGoogleAd={update}
          deleteGoogleAd={close && del}
          onBack={onBack}
          onDuplicate={onDuplicate}
          showUserFlow={showUserFlow}
        />
      )}
      {userError && (
        <Box ta="right">
          <ErrorMessage message={userError.message} />
        </Box>
      )}
    </>
  );
};

export default GoogleAdDetailsForm;
